// extracted by mini-css-extract-plugin
module.exports = {"container":"_20vVa","link":"_1-Iw1","term":"JgIB6"};